import * as actionType from "./userActionType";

const initialState = {
    isLoading: false,
    isSaved:false,
    users:[],
};

export const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.UPDATE_USER:
            return {
                ...state,
                isLoading: true,
                isSaved: false,
            };
        case actionType.UPDATE_USER_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.UPDATE_USER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSaved: true,
            };
        case actionType.GET_USER:
            return {
                ...state,
                isLoading: true,
                isSaved: false,
            };
        case actionType.GET_USER_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.GET_USER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                users: action?.payload?.data?.rows || [],
            };
        default:
            return state;
    }
}